<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as SUPPLIER_ORG_TYPES } from './store'
import OrganizationCommonFiltersMixin from '../../../components/organization/mixins/OrganizationCommonFiltersMixin'

export default {
  name: 'SupplierOrganizationCommonFilters',
  mixins: [OrganizationCommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: SUPPLIER_ORG_TYPES.GENERIC.organization.supplierorganization.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...SUPPLIER_ORG_TYPES.GENERIC.organization.supplierorganization.LIST.ACTIONS
    })
  }
}
</script>
